import type { Chat, ChatLabel } from '@/data/types';
import { useChats } from '@/data/store';
import { CheckIcon } from './Icons';

// Shared labels (Gary, 15 Oct): a quiet coloured line on a chat row, and a picker sheet.
// The list itself is kept by head office in the Portal (Admin, WhatsApp, Labels).

export function LabelLine({ labels, inline = false }: { labels: ChatLabel[] | undefined; inline?: boolean }) {
  if (!labels?.length) return null;
  return (
    <div className={`chats-labels${inline ? ' chats-labels--inline' : ''}`}>
      {labels.map((l) => <span key={l.id} className={`chats-label chats-label--${l.colour}`}>{l.name}</span>)}
    </div>
  );
}

export function LabelSheet({ chat }: { chat: Chat }) {
  // Read live from the store, so ticks follow each tap while the sheet is open.
  const { chats, labels, setLabel } = useChats();
  const current = chats.find((c) => c.id === chat.id) ?? chat;
  const on = new Set((current.labels ?? []).map((l) => l.id));
  return (
    <>
      <h2 className="chats-sheet-title">Labels</h2>
      <p className="chats-sheet-hint">Everyone who can see this chat sees its labels. Head office keeps the list in the Portal.</p>
      {labels.length === 0 && <p className="chats-sheet-hint">No labels yet.</p>}
      {labels.map((l) => (
        <button key={l.id} type="button" className="chats-opt" aria-pressed={on.has(l.id)} onClick={() => setLabel(chat.id, l.id, !on.has(l.id))}>
          <span className={`chats-opt-icon chats-label-dot chats-label--${l.colour}`} />
          <span className="chats-opt-text"><b>{l.name}</b></span>
          {on.has(l.id) && <span className="chats-label-tick"><CheckIcon /></span>}
        </button>
      ))}
    </>
  );
}
